/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_001: Question = {
  id: 'gov-001-document-officiel-engagement',
  oldId: '1',
  number: '1.1',
  title: 'Création d\'un document officiel démontrant son engagement',
  idEM: 1,
  type: QuestionType.ACTIVITY,
  description: ['Un document officiel prônant l’engagement moral de l’organisation municipale à égard de la préservation de la biodiversité (par exemple, une résolution d’appui) a été adopté par le conseil municipal.'],
  frequency: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoringFct: (data: string[]) => parseFloat(data[0]),
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_001_v2: Question = question_gov_001;
export const question_gov_001_v3: Question = question_gov_001;
